<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado borderTop v-else-if="ativarLoading" :titulo="titulo" :classe="nomeImposto" />
  <MensagemIpi v-else-if="dadosForm.regra == 0" :titulo="titulo" :classe="nomeImposto" />
  <MultiplosSemResultado v-else-if="!exibeImposto" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">PIS/COFINS</h2>
    <!-- ajustar exibição do QuadroAlerta -->
    <QuadroAlerta
      :classe="nomeImposto"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroPrincipal
      :key="getRenderKey"
      :borderTop="!exibeAlerta"
      :titulo="imposto.nome"
      :classe="imposto.classe"
    >
      <RegistrosPisCofins
        :imposto="imposto"
        :registroSelecionado="registroSelecionado"
        :selecionouPisCofins="selecionouPisCofins"
        :seleciona="seleciona"
        :edita="edita"
      />
    </QuadroPrincipal>
    <QuadroCreditoPresumido
      v-if="selecionouPisCofins && credito"
      :classe="nomeImposto"
      :registro="credito"
    />
  </div>
</template>

<script>
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import MensagemIpi from "@/components/MensagemIpi/MensagemIpi.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import MultiplosSemResultado from "@/components/ImpostoSemResultado/MultiplosSemResultado.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import RegistrosPisCofins from "@/components/RegistrosPisCofins/RegistrosPisCofins.vue";
import QuadroCreditoPresumido from "@/components/QuadroCreditoPresumido/QuadroCreditoPresumido.vue";
import QuadroAlerta from "../../../components/QuadroAlerta/QuadroAlerta.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "PisCofins",
  props: {
    id: String | Number,
    buscarImposto: Function,
    tributoAtivo: String,
    limparImpostos: Boolean,
    exibeImposto: Boolean,
    dadosForm: Array | Object
  },

  components: {
    LoadingResultado,
    MensagemIpi,
    MensagemErro,
    MultiplosSemResultado,
    QuadroPrincipal,
    RegistrosPisCofins,
    QuadroCreditoPresumido,
    QuadroAlerta
  },

  data() {
    return {
      exibeAlerta: false,
      titulo: "PIS/COFINS",
      ativarLoading: false,
      nomeImposto: "pis_cofins",
      imposto: null,
      registroSelecionado: {},
      selecionouPisCofins: false,
      erro: false,
      exibeAlerta: false,
      credito: null
    };
  },

  created() {
    this.setSelecao({ selecao: { selecionouPisCofins: this.selecionouPisCofins }, id: this.id });
  },

  updated() {
    if (this.selecionouPisCofins) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      //olha se o tributo esta ativo, se nao há dado que ja foi chamado e se existe IPI selecionado.
      if (
        newValue == this.nomeImposto &&
        !this.imposto &&
        this.dadosForm.regra != 0 &&
        this.exibeImposto
      ) {
        this.ativarLoading = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            tentativas = 3;

            [this.credito] = this.imposto.credito_presumido;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoading = false;
            }
          }
        }
        this.ativarLoading = false;
      }
    },

    limparImpostos(newValue) {
      if (newValue) {
        this.imposto = null;
        this.edita();
      }
    },

    ativarLoading() {
      this.$emit("loading", this.ativarLoading);
    },

    selecionouPisCofins() {
      this.setSelecao({ selecao: { selecionouPisCofins: this.selecionouPisCofins }, id: this.id });
    }
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),

    impressaoLog() {
      let log = {
        logPisCofins: {
          imposto: this.registroSelecionado
        }
      };
      return log;
    }
  },

  methods: {
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    seleciona(imposto) {
      this.registroSelecionado = imposto;
      this.selecionouPisCofins = true;
    },

    edita() {
      this.registroSelecionado = {};
      this.selecionouPisCofins = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
